import { SaveData } from '../systems/SaveSystem';

export interface AchievementSummary {
  kerisFound: number;
  kerisTotal: number;
  earthquakeSurvived: boolean;
  earthquakePerfect: boolean;
  emergencyBagDone: boolean;
  safeRouteChosen: boolean;
  citizensHelped: boolean;
}

export function getAchievementSummary(save: SaveData): AchievementSummary {
  const completed = save.completedQuests;
  return {
    kerisFound: save.collectedKeris.length,
    kerisTotal: 3,
    earthquakeSurvived: completed.includes('zone2_survive_earthquake'),
    earthquakePerfect: save.earthquakeNoHit === true,
    emergencyBagDone: completed.includes('zone3_emergency_bag'),
    safeRouteChosen: completed.includes('zone4_safe_route'),
    citizensHelped: completed.includes('zone5_escort_safe')
      && !completed.includes('zone5_panic_path'),
  };
}

export function formatAchievementLines(summary: AchievementSummary): string[] {
  const yes = '✓ Selesai';
  const no = '✗ Belum';
  const partial = (done: boolean) => (done ? yes : no);

  return [
    `Keris Pusaka: ${summary.kerisFound}/${summary.kerisTotal}`,
    `Selamat dari gempa: ${partial(summary.earthquakeSurvived)}`,
    `Lolos tanpa cedera: ${summary.earthquakePerfect ? yes : (summary.earthquakeSurvived ? 'Terkena reruntuhan' : no)}`,
    `Tas Siaga Bencana: ${partial(summary.emergencyBagDone)}`,
    `Jalur aman dipilih: ${partial(summary.safeRouteChosen)}`,
    `Warga rentan dibantu: ${partial(summary.citizensHelped)}`,
  ];
}
